import React from 'react';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all',
      '& b': {
        wordBreak: 'break-all'
      }
    }
  };
});

const IntroductionConsultingStartBubble: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
            color="primary"
          >
            상담시작
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            견적서 없이 파트너와 상담을 시작했습니다. 상담을 진행한 후 견적서를
            받아 거래를 진행할 파트너를 선정하세요.
            <br />
            <br />
            견적서 요청은 우측 <b>[견적서]</b> 메뉴에서 할 수 있습니다.
            <br />
            <br />
            견적 상담이 완료되었다면 협의된 견적서를 바탕으로 우측&nbsp;
            <b>[발주서]</b>
            메뉴에서 발주할 수 있습니다.
          </CustomizedTypography>
        </div>
      </div>
    </Box>
  );
};

export default IntroductionConsultingStartBubble;
